/* src/app/shared/components/login/login.component.scss */
.login {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
/*# sourceMappingURL=login.component.css.map */
